import IFiltroItem from "./IFiltroItem";
import IFiltroProps from "./IFiltroProps";

export enum Grupo{
    TIPO = "tipo",
    SITUACAO = "situação",
    DATA = "data",
    ANO = "ano"
}

export default interface IFiltro {    
    item:IFiltroItem
    props:IFiltroProps
}